import { render, staticRenderFns } from "./EmployeeInfoForm.vue?vue&type=template&id=45e1c6f7"
import script from "./EmployeeInfoForm.vue?vue&type=script&lang=js"
export * from "./EmployeeInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports